import { FC, JSX } from "react";
import {
  View,
  Text,
} from "react-native";
import BlueIcon from "@/assets/icons/main/blueAlert.svg"
import DownloadIcon from "@/assets/icons/main/download.svg"
import CustomButton from "@/app/components/CustomButton";

interface IIndividualCheckHeaderProps {
  totalReports: number;
}

const IndividualCheckHeader: FC<IIndividualCheckHeaderProps> = ({ totalReports }): JSX.Element => {
  const downloadAgreement = (): void => {
    const link: HTMLAnchorElement = document.createElement("a");
    link.href = "/files/document.docx";
    link.download = "Согласие на обработку ПД.docx";
    link.click();
  };

  return (
    <>
      <Text className="mr-auto py-1 px-3 mb-3 text-subhead blue-banner rounded-3xl">
        {totalReports} проверок осталось
      </Text>
      <Text className="text-header">
        Проверка физического лица
      </Text>
      <Text className="text-subhead">
        Пожалуйста, введите необходимые данные физического лица.
      </Text>
      <View className="mb-6 p-4 gray-banner">
        <View className="flex-row items-center mb-3">
          <BlueIcon className="mr-3" />
          <Text className="text-base">Обработка данных допустима только с согласия физ.лица.</Text>
        </View>
        <CustomButton
          title="Скачать форму согласия"
          type="filled"
          suffixIcon={<DownloadIcon stroke="#1677FF" />}
          onPress={downloadAgreement}
        />
      </View>
    </>
  );
};

export default IndividualCheckHeader;
